export default "__VITE_ASSET__BJ1cA90w__"